// Components/redux/locationsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const locationsSlice = createSlice({
  name: 'locations',
  initialState: {
    items: [],
    selectedLocationId: null,  // Seçili adres ID’si burada tutulacak
  },
  reducers: {
    setLocations: (state, action) => {
      state.items = action.payload;
    },
    addLocation: (state, action) => {
      // Yeni bir lokasyon nesnesi: { id, name, address, city, mobile }
      state.items.push(action.payload);
    },
    updateLocation: (state, action) => {
      const { id, name, address, city, mobile, deliveryLocation, deliveryPrice } = action.payload;
      const loc = state.items.find(item => item.id === id);
      if (loc) {
        loc.name = name;
        loc.address = address;
        loc.city = city;
        loc.mobile = mobile;
        loc.deliveryLocation = deliveryLocation;
        loc.deliveryPrice = deliveryPrice;
      }
    },
    removeLocation: (state, action) => { 
      state.items = state.items.filter(item => item.id !== action.payload);
      // Eğer silinen, seçili adres ise, seçimi temizle
      if (state.selectedLocationId === action.payload) {
        state.selectedLocationId = null;
      }
    },
    clearLocations: (state) => {
      state.items = [];
      state.selectedLocationId = null;
    },
    setSelectedLocation: (state, action) => {
      state.selectedLocationId = action.payload;
    },
  },
});

export const {
  setLocations,
  addLocation,
  updateLocation,
  removeLocation,
  clearLocations,
  setSelectedLocation,
} = locationsSlice.actions;

export default locationsSlice.reducer;
